import Button from 'react-bootstrap/Button';
import { Spinner } from 'react-bootstrap';

function AddButton({
  text,
  onClick,
  className,
  variant = 'primary',
  disabled = false,
  loading = false,
}) {
  return (
    <Button
      variant={variant}
      className={`d-flex align-items-center justify-content-center ${className}`}
      onClick={() => onClick()}
      disabled={disabled}
    >
      {loading ? (
        <>
          <Spinner
            as='span'
            animation='border'
            size='sm'
            role='status'
            aria-hidden='true'
            className='me-2'
          />
          <span className='visually-hidden'>Loading...</span>
        </>
      ) : (
        <span
          className='material-symbols-outlined me-2'
          style={{ fontSize: '18px' }}
        >
          add
        </span>
      )}

      {text}
    </Button>
  );
}

export default AddButton;
